import { PropTypes } from 'prop-types'
import { Children, cloneElement } from 'react'

import { actions, connect, selectors } from '../../../../stores'

/**
 * if trackChildClick is true, don't inject track, and instead add an onClick listener
 * to all of the children passed
 * Supports wrapping a third party component that accepts click events
 * @param {boolean} trackChildClick - whether we should add an onClick listener to the child
 * @param {function} [childOnClick] - the child's current onClick prop
 * @param {function} onTrack
 * @returns {Function|undefined|*}
 */
const childClick = (trackChildClick, childOnClick, onTrack) => {
  let clickFunction
  if (!trackChildClick) {
    if (typeof childOnClick === 'function') {
      clickFunction = childOnClick
    }
  } else {
    clickFunction = (...args) => {
      onTrack()
      if (typeof childOnClick === 'function') {
        childOnClick(...args)
      }
    }
  }
  return clickFunction
}

const Track = ({
  brandId,
  event,
  data,
  children,
  trackChildClick,
  track,
  retailerAccountId,
  retailerId,
}) => {
  const onTrack = (eventOverride, dataOverride) => {
    const trackEvent = eventOverride || event
    if (trackEvent) {
      track({
        event: trackEvent,
        data: {
          brandId,
          retailerAccountId,
          retailerId,
          ...data,
          ...dataOverride,
        },
      })
    }
  }

  return Children.map(children, (child) => {
    return cloneElement(child, {
      ...child.props,
      onClick: childClick(trackChildClick, child.props.onClick, onTrack),
      track: !trackChildClick ? onTrack : undefined,
    })
  })
}

Track.propTypes = {
  brandId: PropTypes.number,
  children: PropTypes.node.isRequired,
  data: PropTypes.object,
  event: PropTypes.string,
  retailerAccountId: PropTypes.number,
  retailerId: PropTypes.number,
  track: PropTypes.func,
  trackChildClick: PropTypes.bool,
}

const mapStateToProps = (state) => ({
  ...selectors.analytics.selectTrackingData(state),
})

const mapDispatchToProps = (dispatch) => ({
  track: (payload) => dispatch(actions.analytics.track(payload)),
})

export default connect(mapStateToProps, mapDispatchToProps)(Track)
